import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ImagesContext } from "../../Context";
import { HtmlTooltip } from "../../patient_reports/health_overview/panels/action_center/ActionRow";

interface Props {
  billingProvider: any;
  claimStatus: string;
}

const BillingProviderInfo: React.FC<Props> = ({
  billingProvider,
  claimStatus,
}) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box className="info-container">
      <Grid container>
        <Grid item xs={3}>
          <Typography className="info-heading-label">
            Organization Name
          </Typography>
          <Typography className="info-heading-text">
            {billingProvider?.name}
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">Address</Typography>
          <Typography className="info-heading-text">
            <>
              {billingProvider?.address}
              <br />
              {billingProvider?.city}, {billingProvider?.state}{" "}
              {billingProvider?.zip}
            </>
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">
            Organization Details
          </Typography>
          <Typography className="info-heading-text">
            <>
              Federal Tax ID: {billingProvider?.federal_tax_id}
              <br />
              Facility NPI: #{billingProvider?.facility_npi}
            </>
          </Typography>
        </Grid>
        {claimStatus !== "submitted" &&
          claimStatus !== "pending_submission" && (
            <Grid item xs={5} display="flex" justifyContent="flex-end">
              <HtmlTooltip
                placement="top"
                arrow
                title={
                  <Box
                    sx={{
                      padding: "8px",
                      background: "#EFE9E8",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "13px",
                      }}
                    >
                      Billing Provider Details: If there is any missing or
                      incorrect information, please contact a Starfield Admin to
                      update your details.
                    </Typography>
                  </Box>
                }
                sx={{
                  tooltip: {
                    backgroundColor: "white",
                    color: "black",
                  },
                  arrow: {
                    color: "white",
                  },
                }}
              >
                <div className="item-icon-container">
                  <img
                    src={images.info_orange_icon}
                    alt="edit Icon"
                    className="action-icon-image"
                    style={{ width: 23, maxHeight: 23 }}
                  />
                </div>
              </HtmlTooltip>
            </Grid>
          )}
      </Grid>
    </Box>
  );
};

export default BillingProviderInfo;
